import src from "IMAGE";
export default { src, width: 361, height: 76, blurWidth: 0, blurHeight: 0};
